// extracted by mini-css-extract-plugin
export default {"Main":"Logout_Main__4Y87d"};